import styled from '@emotion/styled'
import {theme} from '../../../../theme'

// Drawer Shell

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  gap: 10px;
`

// Header

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #e2e8f0;
`

export const DrawerHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[4]};
`

export const DrawerIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: #f4f6fb;
`

export const DrawerTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
`

export const DrawerLabel = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: #627185;
  letter-spacing: 0.3;
  text-transform: uppercase;
`

export const DrawerTitle = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: ${theme.fontWeights.bold};
  color: #0f172a;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  opacity: 70%;
`

// Body

export const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

// Section

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SectionTitle = styled.p`
  font-size: 12px;
  font-weight: ${theme.fontWeights.bold};
  color: #050505;
  margin: 0;
`

// Details Grid
// Two-column grid for the detail cells.

export const DetailsGrid = styled.div`
  display: flex;
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;
  gap: 4px;
  padding: 10px;
  background-color: #f1f5ff;
  border-radius: 12px;
`

// Individual grid cell — border-right and border-bottom controlled via props
export const GridCell = styled.div`
  border-right: ${({borderRight}) =>
    borderRight ? `1px solid ${theme.colors.border.light}` : 'none'};
  border-bottom: ${({borderBottom}) =>
    borderBottom ? `1px solid ${theme.colors.border.light}` : 'none'};
  grid-column: ${({fullWidth}) => (fullWidth ? '1 / -1' : 'auto')};
`

// Detail Cell

export const DetailCellWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f1f5ff;
  border-radius: 12px;
  gap: 16px;
  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.border.light};
  }
`

export const DetailCellIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: #dfe5f7;
`

export const DetailCellContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const DetailCellLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #627185;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`

export const DetailCellValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
`

// Pay Badge

export const PayBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  gap: 10px;
  padding: 2px 11px;
  background: #308ce81a;
  border: 1px solid #2563eb;
  color: #2563eb;
  font-weight: 600;
  font-size: 12px;
`

// Subscriptions Panel

export const SubscriptionsPanel = styled.div`
  background-color: #f1f5ff;
  border-radius: 10px;
  // border: 1px solid ${theme.colors.border.light};
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`

export const SubscriptionTag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  // border: 1px solid ${theme.colors.border.default};
  font-size: 12px;
  color: ${theme.colors.text.primary};
  background-color: #ffffff;
  white-space: nowrap;
`

export const PanelMessage = styled.p`
  font-size: ${theme.fontSizes.base};
  color: ${({isError}) =>
    isError ? theme.colors.status.danger.text : theme.colors.text.muted};
  margin: 0;
`

export const DotsLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({centered}) => (centered ? 'center' : 'flex-start')};
  gap: ${theme.space[1]};
  width: ${({centered}) => (centered ? '100%' : 'auto')};
`

export const Dot = styled.div`
  width: 5px;
  height: 5px;
  border-radius: ${theme.radii.full};
  background-color: ${theme.colors.text.muted};
  animation: dotBounce 1.2s ease-in-out infinite;
  animation-delay: ${({index}) => index * 0.2}s;

  @keyframes dotBounce {
    0%,
    80%,
    100% {
      opacity: 0.3;
      transform: scale(0.8);
    }
    40% {
      opacity: 1;
      transform: scale(1.2);
    }
  }
`
